<template>
  <a-modal
    :visible="visible"
    :width="860"
    title="APP 下载引导二维码"
    :mask-closable="false"
    @cancel="close"
  >
    <a-alert
      message="雇主端与师傅端各一张二维码。扫码后自动跳转：iPhone 跳 App Store；Android 优先拉起手机自带应用市场（按包名匹配），失败回退下载 APK；微信内引导浏览器打开。iOS 链接与 Android 兜底 APK 链接取自「APP版本管理」最新已发布版本，无需在此维护；此处仅需维护 Android 包名与 H5 链接前缀。"
      type="info"
      show-icon
      style="margin-bottom: 16px"
    />

    <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" style="margin-bottom: 8px">
      <a-form-item label="H5 链接前缀">
        <a-input v-model="h5Base" placeholder="例如 https://admin.hddlg.com.cn/h5" :max-length="200" allow-clear />
        <div class="form-hint">二维码内容 = H5前缀 + /#/pages/share/download/download?app=雇主端|师傅端，修改后自动重新生成并记忆。</div>
      </a-form-item>
    </a-form>

    <a-row :gutter="24">
      <a-col v-for="item in qrList" :key="item.appIdent" :span="12">
        <a-card :title="item.appName" size="small" align="center">
          <div v-if="item.loading" class="qr-status">加载中...</div>
          <div v-else class="qr-box">
            <vue-qr
              :ref="'qr_' + item.appIdent"
              :callback="data => onQrReady(item.appIdent, data)"
              :margin="10"
              :size="220"
              :text="qrText(item)"
            />
          </div>
          <div class="qr-url" :title="qrText(item)">{{ qrText(item) }}</div>
          <div class="qr-meta">
            <div class="qr-meta__row">
              <span class="qr-meta__label">Android 包名</span>
              <a-input
                v-model="item.androidPackageName"
                size="small"
                placeholder="例如 uni.app.UNI08822AB"
                :max-length="100"
                style="flex: 1"
              />
            </div>
            <div class="qr-meta__line" :title="item.iosMarketUrl">iOS App Store：{{ item.iosMarketUrl || '未配置（取自版本管理 upUrl）' }}</div>
            <div class="qr-meta__line" :title="item.androidFallbackUrl">Android 兜底 APK：{{ item.androidFallbackUrl || '未配置（取自版本管理 downloadUrl）' }}</div>
          </div>
          <div class="qr-actions">
            <a-button size="small" @click="copyText(qrText(item), '中转页链接已复制')">复制链接</a-button>
            <a-button size="small" @click="copyText(item.androidPackageName, '包名已复制')" :disabled="!item.androidPackageName">复制包名</a-button>
            <a-button size="small" type="primary" @click="downloadQr(item)">下载二维码</a-button>
          </div>
        </a-card>
      </a-col>
    </a-row>

    <template slot="footer">
      <a-button @click="close">关闭</a-button>
      <a-button type="primary" :loading="saving" @click="handleSave">保存设置</a-button>
    </template>
  </a-modal>
</template>

<script>
import VueQr from 'vue-qr'
import { listDownloadConfig, saveDownloadConfig } from '@/api/app/appVersion'

// 默认 H5 前缀按环境注入：.env.test → share.hddlg.com.cn（测试）；.env.production → share.hddlg.com（生产）
// 注：app-share 打包产物静态资源是 /static/... 绝对路径，只能部署在域名根路径，故此处不带 /h5
const H5_BASE_KEY = 'app_download_h5_base_v2'
const DEFAULT_H5_BASE = (process.env.VUE_APP_H5_BASE || 'https://share.hddlg.com.cn')
  .trim()
  .replace(/^['"]|['"]$/g, '')
  .replace(/\/+$/, '')

export default {
  name: 'DownloadQrModal',
  components: { VueQr },
  data() {
    return {
      visible: false,
      saving: false,
      h5Base: DEFAULT_H5_BASE,
      qrDataMap: {},
      qrList: [
        { appIdent: 'guzhu', appName: '雇主端', androidPackageName: '', iosMarketUrl: '', androidFallbackUrl: '', loading: false },
        { appIdent: 'shifu', appName: '师傅端', androidPackageName: '', iosMarketUrl: '', androidFallbackUrl: '', loading: false }
      ]
    }
  },
  methods: {
    open() {
      this.h5Base = localStorage.getItem(H5_BASE_KEY) || DEFAULT_H5_BASE
      this.visible = true
      this.loadConfig()
    },
    close() {
      this.visible = false
    },
    qrText(item) {
      return `${this.h5Base}/#/pages/share/download/download?app=${item.appIdent}`
    },
    loadConfig() {
      this.qrList.forEach(item => { item.loading = true })
      listDownloadConfig().then(res => {
        const list = (res && res.data) || []
        list.forEach(row => {
          const target = this.qrList.find(it => it.appIdent === row.appIdent)
          if (target) {
            target.androidPackageName = row.androidPackageName || ''
            target.iosMarketUrl = row.iosMarketUrl || ''
            target.androidFallbackUrl = row.androidFallbackUrl || ''
            target.appName = row.appName || target.appName
          }
        })
      }).catch(() => {
        this.$message.error('获取下载配置失败')
      }).finally(() => {
        this.qrList.forEach(item => { item.loading = false })
      })
    },
    handleSave() {
      localStorage.setItem(H5_BASE_KEY, this.h5Base)
      const paramList = this.qrList.map(item => ({
        appIdent: item.appIdent,
        androidPackageName: (item.androidPackageName || '').trim()
      }))
      this.saving = true
      saveDownloadConfig(paramList).then(() => {
        this.$message.success('保存成功')
        this.loadConfig()
      }).catch(() => {
        this.$message.error('保存失败')
      }).finally(() => {
        this.saving = false
      })
    },
    onQrReady(appIdent, dataUrl) {
      this.qrDataMap[appIdent] = dataUrl
    },
    copyText(text, msg) {
      if (!text) {
        return
      }
      this.$copyText(text).then(() => {
        this.$message.success(msg)
      }).catch(() => {
        this.$warning({ title: '请手动复制', content: text })
      })
    },
    downloadQr(item) {
      const dataUrl = this.qrDataMap[item.appIdent]
      if (!dataUrl) {
        this.$message.error('二维码尚未生成完成，请稍后重试')
        return
      }
      const link = document.createElement('a')
      link.href = dataUrl
      link.download = `点点灵工-${item.appName}-下载二维码.png`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style scoped>
.qr-status {
  height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
}
.qr-box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
}
.qr-url {
  font-size: 12px;
  color: #666;
  word-break: break-all;
  text-align: center;
  margin: 6px 0 8px;
  padding: 0 4px;
}
.qr-meta {
  font-size: 12px;
  color: #999;
  text-align: left;
  line-height: 1.8;
  margin-bottom: 10px;
  word-break: break-all;
  padding: 0 4px;
}
.qr-meta__row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.qr-meta__label {
  flex-shrink: 0;
  color: #999;
}
.qr-meta__line {
  color: #999;
}
.qr-actions {
  display: flex;
  justify-content: center;
  gap: 8px;
}
.form-hint {
  margin-top: 4px;
  font-size: 12px;
  color: #bbb;
  line-height: 1.5;
}
</style>
